import { useMutation } from '@tanstack/react-query';
import { useMixpanel } from 'react-mixpanel-browser';

import { refreshCachedDevice } from '@/api/devices';
import { PostDeactivateSharingPayload, PostDeactivateSharingResponse } from '@/api/shareData/types';
import { axios } from '@/common/axios';
import { MutationConfig } from '@/common/react-query';
import { useErrorContext } from '@/context/ErrorContext';

export const postDeactivateSharing = (
    payload: PostDeactivateSharingPayload
): Promise<PostDeactivateSharingResponse> => {
    return axios.post('/device/deactivate-sharingpermissionspublic', payload);
};

type UsePostDeactivateSharingOptions = {
    config?: MutationConfig<typeof postDeactivateSharing>;
    data?: PostDeactivateSharingPayload;
};

export const usePostDeactivateSharing = ({ config }: UsePostDeactivateSharingOptions = {}) => {
    const { createErrorHandler } = useErrorContext();
    const mixpanel = useMixpanel();
    return useMutation({
        ...config,
        mutationFn: postDeactivateSharing,
        onSuccess: (data, variables) => {
            refreshCachedDevice(variables.spotterId);
            mixpanel?.track('Device data sharing deactivated', {
                spotterId: variables.spotterId,
            });
        },
        onError: createErrorHandler('deactivate sharing'),
    });
};
